import * as React from "react";

import styled from "@emotion/styled";
import { Link } from "gatsby";
import LogoMarkWhite from "../../svgs/logo-mark-white.svg";
import Wisconsin from "../../svgs/wisconsin.svg";
import Pennsylvania from "../../svgs/pennsylvania.svg";
import Inc5000 from "../../images/trusted-by/inc-5000.png";
// import Linkedin from '../../svgs/linkedin.svg';
// import Twitter from '../../svgs/twitter.svg';
// import Facebook from '../../svgs/facebook.svg';
import { breakpoints } from "../../styles/breakpoints";
import { PricingLink } from "../pricing-link";

const StyledFooter = styled.footer`
  background: var(--black);
  color: var(--white);

  a {
    font-weight: 400;
  }

  .top {
    display: flex;
    justify-content: space-between;
    padding: var(--small) 0 var(--large);

    @media (max-width: ${breakpoints.md}) {
      flex-wrap: wrap;

      & > * {
        &:not(:first-child) {
          margin-top: var(--small);
        }

        &:first-child {
          display: flex;
          justify-content: center;
          flex: 0 0 100%;
        }
      }
    }

    @media (max-width: ${breakpoints.sm}) {
      max-width: 60rem;
      margin: auto;
      padding-bottom: var(--small);

      & > * {
        &:not(:first-child) {
          flex: 0 0 20rem;
          margin: var(--x-small);
        }
      }
    }

    @media (max-width: 550px) {
      flex-direction: column;
      align-items: center;

      & > * {
        &:not(:first-child) {
          flex: 0;
          width: 25rem;
          margin: var(--small) 0 0;
        }
      }
    }
  }

  li:not(:last-of-type) {
    margin-bottom: var(--nano);
  }

  li:first-of-type {
    margin-bottom: var(--macro);
    font-size: var(--p-normal);
    font-weight: 700;
    text-transform: uppercase;
  }

  .location {
    div {
      display: flex;
      align-items: center;
    }

    img {
      height: 6rem;
      width: 5rem;
      margin-right: var(--macro);

      @media (max-width: ${breakpoints.md}) {
        height: 5rem;
        margin-right: var(--micro);
      }
    }

    &:not(:last-child) {
      margin-bottom: var(--xx-small);
    }
  }

  /* .social-links {
    li {
      display: flex;
      align-items: center;

      &:not(:first-of-type) {
        margin-bottom: var(--micro);
      }
    }

    img {
      height: 2rem;
      width: 2rem;
      margin-right: var(--macro);
    }
  } */

  .bottom {
    display: flex;
    justify-content: space-between;
    padding: var(--xx-small) 0;
    border-top: 1px solid #353535;

    @media (max-width: ${breakpoints.lg}) {
      flex-direction: column;
      align-items: center;
      text-align: center;

      & > div {
        margin-top: var(--macro);
      }
    }

    & > div {
      a {
        &:first-child {
          padding-right: var(--xx-small);
        }

        &:last-child {
          padding-left: var(--xx-small);
        }

        &:not(:last-child) {
          border-right: 1px solid var(--white);
        }
      }
    }
  }

  .images {
    display: grid;
    gap: var(--xx-small);
  }

  .inc-5000 {
    height: 70px;
    border: 1px solid #fff;
    border-radius: 50%; 
    filter: grayscale(100%);
  }

  .logo {
    width: 80px;
  }
`;

export const Footer = () => (
  <StyledFooter>
    <div className="row">
      <div className="top">
        <div className="images">
          <img src={LogoMarkWhite} alt="Agency Elevation" className="logo" />
          <img src={Inc5000} alt="Inc 5000" className="inc-5000"/>
        </div>
        <ul>
          <li>White Label Services</li>
          <li>
            <Link to="/white-label-seo-services">White Label SEO</Link>
          </li>
          <li>
            <Link to="/white-label-ppc-management">White Label PPC</Link>
          </li>
          <li>
            <Link to="/white-label-facebook-ads">White Label Facebook Ads</Link>
          </li>
          <li>
            <Link to="/white-label-tiktok-ads">White Label TikTok Ads</Link>
          </li>
        </ul>
        <ul>
          <li>Agency</li>
          <li>
            <Link to="/results">Results</Link>
          </li>
          <li>
            <Link to="/about#founding-partners">Team</Link>
          </li>
          <li>
            <PricingLink to="/pricing">Plans & Pricing</PricingLink>
          </li>
          <li>
            <Link to="/contact">Contact</Link>
          </li>
          {/* <li>
            <Link to="/blog">Blog</Link>
          </li> */}
        </ul>
        <ul>
          <li>Locations</li>
          <li className="location">
            <div>
              <img src={Wisconsin} alt="Wisconsin" />
              <a href="tel:9204604739">
                Wisconsin
              </a>
            </div>
          </li>
          <li className="location">
            <div>
              <img src={Pennsylvania} alt="Pennsylvania" />
              <a href="tel:4123981192">
                Pennsylvania
              </a>
            </div>
          </li>
        </ul>
        {/* <ul className="social-links">
          <li>Social</li>
          <li>
            <img src={Linkedin} alt="Linkedin" />
            <a href="https://www.linkedin.com/company/agencyelevation/" target="_blank">Linkedin</a>
          </li>
          <li>
            <img src={Twitter} alt="Twitter" />
            <a href="https://twitter.com/AgencyElevation" target="_blank">Twitter</a>
          </li>
          <li>
            <img src={Facebook} alt="Facebook" />
            <a href="https://www.facebook.com/AgencyElevation/" target="_blank">Facebook</a>
          </li>
        </ul> */}
      </div>
      <div className="bottom">
        <p>
          &copy; 2012-{new Date().getFullYear()} Option One Marketing, LLC DBA Agency Elevation. All rights reserved.
        </p>
        <div>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-of-service">Terms of Service</Link>
        </div>
      </div>
    </div>
  </StyledFooter>
);
